import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import bannersImg from '../assets/logo/pics.png';
import bannerImg from '../assets/logo/pic1.png';

const slides = [
  {
    tag: 'Premium Quality',
    line1: 'Pure Spices',
    line2: 'Soulful Taste.',
    img: bannersImg,
  },
  {
    tag: 'Freshly Packed',
    line1: 'Organic &',
    line2: 'Pure Masalas.',
    img: bannerImg,
  },
];

const LeafIcon = ({ size = 28, color = '#70AD1A', opacity = 1 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity }}>
    <path d="M32 4C32 4 10 16 10 36C10 50 20 58 32 60C44 58 54 50 54 36C54 16 32 4 32 4Z" fill={color} />
    <path d="M32 60C32 60 32 30 32 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M32 20C32 20 22 28 18 36" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
    <path d="M32 20C32 20 42 28 46 36" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
  </svg>
);

const leafPositions = [
  { top: '8%',  left: '38%', size: 32, rotate: -30, color: '#70AD1A', opacity: 0.85, animDelay: '0s',   animDur: '3s'   },
  { top: '75%', left: '28%', size: 26, rotate: 40,  color: '#5a9a10', opacity: 0.75, animDelay: '0.5s', animDur: '3.5s' },
  { top: '80%', left: '72%', size: 22, rotate: -50, color: '#70AD1A', opacity: 0.65, animDelay: '1s',   animDur: '4s'   },
  { top: '5%',  left: '78%', size: 20, rotate: 20,  color: '#4e8a0e', opacity: 0.6,  animDelay: '1.5s', animDur: '3.2s' },
  { top: '50%', left: '5%',  size: 18, rotate: 60,  color: '#70AD1A', opacity: 0.5,  animDelay: '0.8s', animDur: '4.5s' },
  { top: '20%', left: '92%', size: 24, rotate: -20, color: '#5a9a10', opacity: 0.7,  animDelay: '0.3s', animDur: '3.8s' },
];

export default function BannerOne() {
  const [animKey, setAnimKey] = useState(0);
  const [hoveredLeaf, setHoveredLeaf] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: false,
    pauseOnHover: false,
    beforeChange: (_, next) => {
      setAnimKey((k) => k + 1);
    },
  };

  return (
    <div className="banner-area" style={{ padding: '50px' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700;800;900&display=swap');

        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-60px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.75) rotate(-4deg); }
          to   { opacity: 1; transform: scale(1) rotate(0deg); }
        }
        @keyframes floatImg {
          0%, 100% { transform: translateY(0px) scale(1); }
          50%       { transform: translateY(-14px) scale(1.03); }
        }
        @keyframes btnPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(112,173,26,0.4); }
          50%       { box-shadow: 0 0 0 10px rgba(112,173,26,0); }
        }
        @keyframes leafFloat {
          0%   { transform: translateY(0px) rotate(var(--leaf-rot)); }
          25%  { transform: translateY(-12px) rotate(calc(var(--leaf-rot) + 8deg)); }
          50%  { transform: translateY(-6px) rotate(calc(var(--leaf-rot) - 5deg)); }
          75%  { transform: translateY(-16px) rotate(calc(var(--leaf-rot) + 3deg)); }
          100% { transform: translateY(0px) rotate(var(--leaf-rot)); }
        }
        @keyframes leafHoverSpin {
          0%   { transform: rotate(var(--leaf-rot)) scale(1); }
          30%  { transform: rotate(calc(var(--leaf-rot) + 180deg)) scale(1.4); }
          60%  { transform: rotate(calc(var(--leaf-rot) + 300deg)) scale(1.6); }
          100% { transform: rotate(calc(var(--leaf-rot) + 360deg)) scale(1); }
        }
        @keyframes leafWiggle {
          0%   { transform: rotate(var(--leaf-rot)) scale(1.5); }
          20%  { transform: rotate(calc(var(--leaf-rot) + 25deg)) scale(1.6); }
          40%  { transform: rotate(calc(var(--leaf-rot) - 20deg)) scale(1.5); }
          60%  { transform: rotate(calc(var(--leaf-rot) + 15deg)) scale(1.55); }
          80%  { transform: rotate(calc(var(--leaf-rot) - 10deg)) scale(1.5); }
          100% { transform: rotate(var(--leaf-rot)) scale(1.5); }
        }
        @keyframes rippleBurst {
          0%   { transform: translate(-50%, -50%) scale(1); opacity: 1; }
          100% { transform: translate(-50%, -50%) scale(8); opacity: 0; }
        }

        .container { width: 100%; margin: 0 auto; }
        .bn-main-wrapper { overflow: hidden; margin: 0 auto; }

        .bn-single-slide {
          display: flex !important;
          flex-direction: row;
          align-items: center;
          min-height: 500px;
          width: 100%;
          position: relative;
          overflow: hidden;
        }

        .bn-text-side {
          flex: 1;
          padding: 40px 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        /* TAG — green uppercase like Orfarm */
        .bn-tag {
          display: inline-block;
          color: #70AD1A;
          text-transform: uppercase;
          margin-bottom: 12px;
          font-family: 'Nunito', sans-serif;
          font-weight: 800;
          letter-spacing: 3px;
          font-size: 13px;
          width: fit-content;
          animation: slideInUp 0.5s cubic-bezier(0.34,1.56,0.64,1) 0.1s both;
        }

        /* HEADING — dark navy, extra bold, Nunito like Orfarm */
        .bn-h1 {
          font-family: 'Nunito', sans-serif;
          font-size: 76px;
          font-weight: 900;
          line-height: 1.05;
          margin: 0 0 20px 0;
          color: #1a2e44;
          letter-spacing: -1px;
        }

        /* Both lines same dark navy — exactly like screenshot */
        .bn-line1 {
          display: block;
          color: #F57C00;
          animation: slideInLeft 0.6s cubic-bezier(0.34,1.56,0.64,1) 0.25s both;
        }
        .bn-line2 {
          display: block;
          color: #1A52A8;
          animation: slideInLeft 0.6s cubic-bezier(0.34,1.56,0.64,1) 0.4s both;
        }

        /* SUB TEXT below heading */
        .bn-sub {
          font-family: 'Nunito', sans-serif;
          font-size: 16px;
          font-weight: 400;
          color: #6b7a8d;
          line-height: 1.7;
          margin-bottom: 32px;
          max-width: 400px;
          animation: slideInUp 0.6s cubic-bezier(0.34,1.56,0.64,1) 0.45s both;
        }

        .bn-image-side {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 2;
          padding: 20px;
        }
        .bn-image-side img {
          max-width: 100%;
          height: auto;
          object-fit: contain;
          filter: drop-shadow(0 20px 40px rgba(0,0,0,0.15));
        }
        .img-float {
          animation:
            zoomIn   0.8s cubic-bezier(0.34,1.56,0.64,1) both,
            floatImg 4s  ease-in-out 0.8s infinite;
        }

        /* BUTTON — solid green like Orfarm */
        .shop-btn {
          background: #70AD1A;
          color: white !important;
          padding: 16px 48px;
          border-radius: 8px;
          text-decoration: none;
          width: fit-content;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-family: 'Nunito', sans-serif;
          font-weight: 800;
          font-size: 14px;
          letter-spacing: 2px;
          text-transform: uppercase;
          transition: all 0.3s ease;
          animation: btnPulse 2.5s ease infinite, slideInUp 0.6s cubic-bezier(0.34,1.56,0.64,1) 0.6s both;
        }
        .shop-btn:hover {
          background: #5a9010;
          transform: translateY(-3px);
          box-shadow: 0 10px 24px rgba(112,173,26,0.4);
          animation: none;
        }
        .shop-btn:active { transform: scale(0.97); }

        .bn-leaf {
          position: absolute;
          z-index: 3;
          cursor: pointer;
          transition: filter 0.3s ease;
          filter: drop-shadow(0 2px 6px rgba(112,173,26,0.3));
        }
        .bn-leaf:hover {
          filter: drop-shadow(0 4px 14px rgba(112,173,26,0.7)) brightness(1.2);
          z-index: 10;
        }
        .bn-leaf svg { display: block; pointer-events: none; }
        .bn-leaf.floating {
          animation: leafFloat var(--leaf-dur) ease-in-out var(--leaf-delay) infinite;
        }
        .bn-leaf.hovered {
          animation: leafHoverSpin 0.6s cubic-bezier(0.34,1.56,0.64,1) forwards,
                     leafWiggle 1.2s ease-in-out 0.6s infinite !important;
        }
        .bn-leaf-ripple {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(112,173,26,0.5);
          transform: translate(-50%, -50%);
          animation: rippleBurst 0.6s ease-out forwards;
          pointer-events: none;
          z-index: 20;
        }

        @media (max-width: 768px) {
          .bn-single-slide { flex-direction: column; text-align: center; }
          .bn-text-side { align-items: center; order: 2; padding: 30px 20px; }
          .bn-image-side { order: 1; padding: 20px; }
          .bn-h1 { font-size: 40px; }
          .bn-tag { font-size: 11px; }
        }
          /* --- MEDIA QUERIES (Add these inside your <style> tag) --- */

        /* iPad and Large Tablets (Landscape & Portrait) */
        @media (max-width: 1024px) {
          .banner-area { padding: 30px !important; } /* Reducing the 50px outer padding */
          
          .bn-h1 { font-size: 58px; } /* Slightly smaller heading */
          
          .shop-btn { 
            padding: 14px 30px; /* Reduced padding for iPad so it's not too wide */
            font-size: 13px;
          }
          
          .bn-text-side { padding: 0 30px; }
        }

        /* Mobile Phones & Small Tablets */
        @media (max-width: 768px) {
          .banner-area { padding: 20px 10px !important; }
          
          .bn-single-slide { 
            flex-direction: column; 
            text-align: center; 
            min-height: auto;
            padding-top: 40px;
          }
          
          .bn-text-side { 
            order: 2; 
            align-items: center; 
            padding: 40px 15px; 
          }
          
          .bn-image-side { 
            order: 1; 
            width: 100%; 
            padding: 10px;
          }
          
          .bn-image-side img { 
            max-width: 75%; 
            margin: 0 auto; 
          }
          
          .bn-h1 { 
            font-size: 38px; 
            line-height: 1.2; 
          }
          
          .bn-sub { 
            margin-left: auto; 
            margin-right: auto; 
            font-size: 15px; 
          }

          .shop-btn { 
            padding: 12px 28px; /* Balanced mobile button */
            font-size: 12px; 
          }

          /* Keeping leaves from overlapping text on small screens */
          .bn-leaf { 
            opacity: 0.3 !important; 
            transform: scale(0.8);
          }
        }

        /* Very Small Phones */
        @media (max-width: 480px) {
          .bn-h1 { font-size: 32px; }
          .shop-btn { padding: 10px 22px; }
          .bn-image-side img { max-width: 90%; }
        }

        .slick-dots { display: none !important; }
      `}</style>

      <div className="container">
        <div className="bn-main-wrapper">
          <Slider {...settings}>
            {slides.map((slide, idx) => (
              <div key={idx}>
                <div className="bn-single-slide">

                  {/* Floating Leaves */}
                  {leafPositions.map((leaf, lIdx) => (
                    <div
                      key={lIdx}
                      className={`bn-leaf ${hoveredLeaf === lIdx ? 'hovered' : 'floating'}`}
                      style={{
                        top: leaf.top,
                        left: leaf.left,
                        '--leaf-rot': `${leaf.rotate}deg`,
                        '--leaf-dur': leaf.animDur,
                        '--leaf-delay': leaf.animDelay,
                      }}
                      onMouseEnter={(e) => {
                        setHoveredLeaf(lIdx);
                        const ripple = document.createElement('div');
                        ripple.className = 'bn-leaf-ripple';
                        ripple.style.left = '50%';
                        ripple.style.top = '50%';
                        e.currentTarget.appendChild(ripple);
                        setTimeout(() => ripple.remove(), 700);
                      }}
                      onMouseLeave={() => setHoveredLeaf(null)}
                    >
                      <LeafIcon size={leaf.size} color={leaf.color} opacity={leaf.opacity} />
                    </div>
                  ))}

                  {/* Text */}
                  <div className="bn-text-side" key={`text-${animKey}`}>
                    <span className="bn-tag">{slide.tag}</span>
                    <h1 className="bn-h1">
                      <span className="bn-line1">{slide.line1}</span>
                      <span className="bn-line2">{slide.line2}</span>
                    </h1>
                    <p className="bn-sub">
                      Presentation matters. Our pure spices and masalas bring authentic flavor to every dish.
                    </p>
                    <Link to="/shop" className="shop-btn">
                      Shop Now
                    </Link>
                  </div>

                  {/* Image */}
                  <div className="bn-image-side">
                    <img
                      key={`img-${animKey}`}
                      src={slide.img}
                      alt={slide.tag}
                      className="img-float"
                    />
                  </div>

                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}